/**
 * Internship configuration
 */
module.config(['$stateProvider', 'urls', function ($stateProvider, urls) {
    'use strict';
    $stateProvider
        .state('internship', {
            url: '/' + urls.internship.fr, // TODO : when multilang, change this to something dynamic
            abstract: true,
            template: '<div ui-view></div>'
        })
        .state('internship.list', {
            url: '?search&activity&universe&region&audience&level&date&lastMinute&instructor&stock&durationMin&durationMax&discountPriceMin&discountPriceMax&accommodation&privatizable',
            reloadOnSearch: false,
            resolve: {
                stopWordsDefined: ['$q', '$rootScope', function ($q, $rootScope) {
                    var deferred = $q.defer();
                    // min delay to activate booking option and check/transfer options
                    $rootScope.$watch('config.site.criteres_recherche.stop_words', function (config) {
                        if (config) {
                            deferred.resolve(config.split(','));
                        }
                    });
                    return deferred.promise;
                }]
            },
            controller: ['$scope', '$rootScope', '$stateParams', '$document', '$timeout', '$filter', 'moment', 'drupal', 'headermanager', 'tools', 'lodash', '$window', 'stopWordsDefined', '$location', '$anchorScroll', 'pattern', 'utils',
                function ($scope, $rootScope, $stateParams, $document, $timeout, $filter, moment, drupal, headermanager, tools, lodash, $window, $stopWords, $location, $anchorScroll, pattern, utils) {

                    $scope.configSite = $rootScope.config.site;
                    $scope.durations = []; // collection of duration per couple produt sfid and base sfid
                    $scope.availableDates = false;
                    $scope.presetDate = false;
                    $scope.pattern = pattern;

                    $scope.criterias_tags = {
                        open: false,
                        value: []
                    };
                    if ($stateParams.search) {
                        $stateParams.search.split(' ').forEach(function (s) {
                            if (!$stopWords.some(function (word) { return word.trim() === s; })) {
                                $scope.criterias_tags.value.push(s);
                                $scope.criterias_tags.open = true;
                            }
                        });
                    }
                    $scope.removeTag = function (tag) {
                        $scope.criterias_tags.value = $scope.criterias_tags.value.filter(function (t) {
                            return t !== tag;
                        });
                        buildResults();
                        checkFacettes();
                        updateRoute();
                    };
                    /* link to anchor handler */
                    $scope.scrollTo = function (dest) {
                        $location.hash(dest);
                        $anchorScroll();
                    };

                    // page loader flag
                    $scope.loading = true;
                    // results loader flag
                    $scope.resultLoading = true;
                    // prevent filter change while waiting request
                    $scope.pending = false;

                    // page model
                    $scope.results = [];

                    // limit number of internships to display
                    $scope.step = 10;
                    $scope.limit = 10;
                    $scope.showMoreLabel = tools.replace($filter('translate')('internship.showMore'), { number: $scope.step });

                    $scope.dateRegex = new RegExp("^(?:(?:31(\\/)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$");

                    // mock banner
                    headermanager.customize({
                        filled: true
                    });
                    var configWatcher = $rootScope.$watch('config.site.internships_banner', function (value) {
                        if (value) {
                            headermanager.customize({
                                filled: true,
                                picture: { type: 'image', src: value.url }
                            });
                        }
                    });

                    $scope.$on('$destroy', function () {
                        configWatcher();
                    });

                    $scope.pageTitle = $filter('translate')('internship.titleLong');
                    $scope.breadcrumb = [
                        { label: $filter('translate')('home'), state: 'homepage' },
                        { label: $filter('translate')('internship.title') }
                    ];

                    // advice & duo panel

                    // sort
                    $scope.sort = [];

                    var durationOptions = {
                        floor: Number.MAX_VALUE,
                        ceil: Number.MIN_VALUE
                    };

                    var participantOptions = {
                        floor: Number.MAX_VALUE,
                        ceil: Number.MIN_VALUE
                    };

                    var budgetOptions = {
                        floor: Number.MAX_VALUE,
                        ceil: Number.MIN_VALUE,
                        translate: function (value) {
                            return $filter('toCurrency')(value, true);
                        }
                    };

                    $scope.filters = {
                        displayed: true,
                        open: true,
                        criteria: [
                            { key: 'activity', type: 'multi', open: true },
                            { key: 'universe', type: 'multi', open: true },
                            { key: 'audience', type: 'multi', open: true },
                            { key: 'stock', type: 'slider', open: true, min: 0, max: 0, options: participantOptions },
                            { key: 'level', type: 'multi', open: true },
                            { key: 'basename', type: 'tree', open: true },
                            { key: 'startDate', type: 'date', open: true },
                            { key: 'duration', type: 'range', open: true, min: 0, max: 0, options: durationOptions },
                            { key: 'discountPrice', type: 'range', open: true, min: 0, max: 0, options: budgetOptions },
                            { key: 'accommodation', type: 'multi', open: true },
                            { key: 'privatizable', type: 'bool', open: true, name: 'Oui', checked: false }
                        ]
                    };
                    $scope.internships = [];
                    $scope.results = [];
                    $scope.dates = [];

                    function forceUpdateRendering() {
                        $timeout(function () {
                            // force slider rendering
                            $scope.$broadcast('rzSliderForceRender');
                            // force sticky (results tail button) rendering
                            evalSticky();
                            // eval if at least one filter criteria is shown
                            $scope.filters.displayed = $scope.filters.criteria.some(function (filter) {
                                return filter.open;
                            });
                        });
                    }

                    function buildResults() {
                        $scope.resultLoading = true;

                        var products = {};
                        $scope.results.length = 0;

                        var availableDates = [];
                        $scope.dates.length = 0;

                        $scope.limit = $scope.step;

                        ($scope.internships || []).forEach(function (internship, index) {
                            var pristine = index === 0; // flag to identify first iteration of criterium list

                            internship.key = internship.product.sfid + '|' + internship.base.sfid;
                            internship.stock = Number(internship.stock);
                            internship.universe = internship.product.universe;
                            internship.level = internship.product.level.value;
                            internship.activity = internship.product.activity;
                            internship.audience = internship.product.audience;
                            internship.duo = internship.product.duo;
                            internship.basename = internship.base.name;
                            internship.slug = internship.slug || $filter('slugify')(internship.product.name);

                            // set reference to min/max duration information
                            var durationId = $scope.durations.findIndex(function (duration) {
                                return duration.productId === internship.product.sfid && duration.baseId === internship.base.sfid;
                            });
                            if (durationId > -1) {
                                // duration found, check if min/max values must be updated within shared model
                                $scope.durations[durationId].durationMin = Math.min($scope.durations[durationId].durationMin || Number.MAX_VALUE, internship.duration);
                                $scope.durations[durationId].durationMax = Math.max($scope.durations[durationId].durationMax || Number.MIN_VALUE, internship.duration);
                            } else {
                                durationId = $scope.durations.push({
                                    productId: internship.product.sfid,
                                    baseId: internship.base.sfid,
                                    durationMin: internship.duration,
                                    durationMax: internship.duration
                                });
                            }
                            internship.durations = $scope.durations[durationId];


                            if(internship.product.page && internship.product.page.field_main_visual && internship.product.page.field_main_visual.length > 0) {
                                internship.main_visual_random =  lodash.sample(internship.product.page.field_main_visual);
                            }
                            else if(internship.product.page && internship.product.page.field_theme) {
                                const theme = lodash.find($scope.themes, { nid: internship.product.page.field_theme });
                                if (theme && theme.field_main_visual) {
                                    internship.main_visual_random =  lodash.sample(theme.field_main_visual);
                                }
                            }

                            if ($scope.filters.criteria.map(function (criterium) {
                                    var filter = { name: criterium.key, active: false, valid: false };
                                    if (criterium.type === 'multi') {
                                        (criterium.options || []).forEach(function (value) {
                                            if (value.checked === true) {
                                                filter.active = true;
                                                if (internship[criterium.key] === value.name) {
                                                    filter.valid = true;
                                                }
                                            }
                                            if (!value.shown && internship[criterium.key] === value.name) {
                                                value.shown = true;
                                            }
                                        });

                                        // show level 0 stage if the selected levels are between 1 and 4
                                        if (criterium.key === 'level' && internship.level === 0) {
                                            var showLevel0 = lodash.every(criterium.options, function(level) {
                                                return !level.checked || level.checked && level.name < 5;
                                            });
                                            filter.valid = showLevel0;
                                        }
                                    } else if (criterium.type === 'tree') {
                                        (criterium.options || []).forEach(function (option) {
                                            option.checked = false;
                                            (option.options || []).forEach(function (value) {
                                                if (value.checked === true) {
                                                    option.checked = true;
                                                    filter.active = true;
                                                    if (internship[criterium.key] === value.name) {
                                                        filter.valid = true;
                                                    }
                                                }
                                                if (!value.shown && internship[criterium.key] === value.name) {
                                                    option.shown = true;
                                                    value.shown = true;
                                                }
                                            });
                                        });
                                    } else if (criterium.type === 'bool' && criterium.checked === true) {
                                        filter.active = true;
                                        if (internship[criterium.key] === true) {
                                            filter.valid = true;
                                        }
                                    } else if (criterium.type === 'range') {
                                        filter.active = true;
                                        if (criterium.min <= internship[criterium.key] && internship[criterium.key] <= criterium.max) {
                                            filter.valid = true;
                                        }
                                    } else if (criterium.type === 'slider') {
                                        filter.active = true;
                                        if (criterium.value <= internship[criterium.key]) {
                                            filter.valid = true;
                                        }
                                    } else if (criterium.type === 'date') {
                                        //if (criterium.value instanceof Date) {
                                        if (moment(criterium.value, ["DD/MM/YYYY"]).isValid()) {
                                            filter.active = true;
                                            if (internship[criterium.key] === moment(criterium.value, ["DD/MM/YYYY", "DD-MM-YYYY"]).format("YYYY-MM-DD")) {
                                                filter.valid = true;
                                            }
                                        }
                                    }
                                    return filter;
                                }).reduce(function (acc, cur) {
                                    return acc || (cur.active && !cur.valid);
                                },  ($stateParams.lastMinute === 'true' && internship.lastMinute !== true) ||
                                    ($stateParams.instructor === 'true' && internship.instructorStock === 0))) {
                                return;
                            }

                            if ($scope.criterias_tags.value.length > 0) {
                                var tInternship = internship.product.name.toLowerCase();
                                if (!$scope.criterias_tags.value.every(function (criteria) {
                                    return tInternship.indexOf(criteria.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")) > -1;
                                })) {
                                    return;
                                }
                            }

                            var startDate = moment(internship.startDate, ["YYYY-MM-DD"]).format("MM/DD/YYYY");
                            if (!availableDates.some(function (date) { return date === startDate; })) {
                                availableDates.push(startDate);
                            }

                            if (!products.hasOwnProperty(internship.key) || $stateParams.lastMinute === 'true') {
                                $scope.results.push(products[internship.key] = angular.copy(internship));
                            } else {
                                products[internship.key].stock += Number(internship.stock);
                                // Here compute price
                                if (internship.discountPrice < products[internship.key].discountPrice) {
                                    products[internship.key].discountPrice = internship.discountPrice;
                                    products[internship.key].price = internship.price;
                                }
                            }
                        });

                        $scope.dates = availableDates;

                        forceUpdateRendering();
                    }

                    $scope.pending = true;

                    $scope.updateLeaves = function (root) {
                        root.options.forEach(function (leaf) {
                            leaf.checked = root.checked;
                        });
                    };

                    // seo

                    var configSiteSeo = $rootScope.$watch('config.site.list_stages_seo', function (config) {
                        if (config) {
                            if (config.keywords) {
                                tools.setMetaValue('keywords', config.keywords);
                            }
                            if (config.description) {
                                tools.setMetaValue('description', config.description);
                            }
                        }
                    });
                    $scope.$on('$destroy', function () {
                        configSiteSeo();
                    });
                    // load results
                    drupal.getCriteria().then(function (criteria) {

                        lodash.forEach(criteria.filters, function (f) {
                            f.weight = parseInt(f.weight);
                        });
                        lodash.forEach(criteria.sort, function (s) {
                            s.weight = parseInt(s.weight);
                        });

                        Object.keys(criteria.filters).forEach(function (k) {
                            angular.merge(lodash.find($scope.filters.criteria, { key: k }), criteria.filters[k]);
                        });
                        angular.merge($scope.sort, lodash.map(criteria.sort, function (v, k) { v.key = k; return v; }));

                        $scope.ordering = $scope.sort.filter(function (s) {return s.weight === 0 || isNaN(s.weight); })[0].value;

                        // slider re-rendering watcher
                        var watched = ['filters.open'];
                        $scope.filters.criteria.filter(function (criterium, index) {
                            if (criterium.type === 'range' || criterium.type === 'slider') {
                                watched.push('filters.criteria[' + index + '].open');
                            }
                        });
                        $scope.$watchGroup(watched, forceUpdateRendering, true);

                        return drupal.getThemes();
                    }).then(function (themes) {
                        $scope.themes = themes;
                        return drupal.getAllSimpleInternships();
                    }).then(function (internships) {
                        $scope.internships = internships;
                        ($scope.internships || []).forEach(function (internship) {
                            durationOptions.floor = Math.min(durationOptions.floor, internship.duration);
                            durationOptions.ceil = Math.max(durationOptions.ceil, internship.duration);
                            budgetOptions.floor = Math.floor(Math.min(budgetOptions.floor, internship.discountPrice));
                            budgetOptions.ceil = Math.max(budgetOptions.ceil, internship.discountPrice);
                            participantOptions.floor = Math.min(participantOptions.floor, internship.stock);
                            participantOptions.ceil = Math.max(participantOptions.ceil, internship.stock);
                        });

                        lodash.find($scope.filters.criteria, { key: 'duration' }).min = durationOptions.floor;
                        lodash.find($scope.filters.criteria, { key: 'duration' }).max = durationOptions.ceil;
                        lodash.find($scope.filters.criteria, { key: 'discountPrice' }).min = budgetOptions.floor;
                        lodash.find($scope.filters.criteria, { key: 'discountPrice' }).max = budgetOptions.ceil;
                        lodash.find($scope.filters.criteria, { key: 'stock' }).value = participantOptions.floor;

                        $scope.savedcriteria = angular.copy($scope.filters.criteria);

                        // Preselect filters
                        if ($stateParams.activity) {
                            (!Array.isArray($stateParams.activity) ? [$stateParams.activity] : $stateParams.activity).forEach(function (activity) {
                                var fActivity = lodash.find(lodash.find($scope.filters.criteria, { key: 'activity' }).options, { name: decodeURI(activity) });
                                if (fActivity) {
                                    fActivity.checked = true;
                                }
                            });
                        }
                        if ($stateParams.audience) {
                            (!Array.isArray($stateParams.audience) ? [$stateParams.audience] : $stateParams.audience).forEach(function (audience) {
                                var fAudience = lodash.find(lodash.find($scope.filters.criteria, { key: 'audience' }).options, { name: decodeURI(audience) });
                                if (fAudience) {
                                    fAudience.checked = true;
                                }
                            });
                        }
                        if ($stateParams.universe) {
                            (!Array.isArray($stateParams.universe) ? [$stateParams.universe] : $stateParams.universe).forEach(function (universe) {
                                var fUniverse = lodash.find(lodash.find($scope.filters.criteria, { key: 'universe' }).options, { name: decodeURI(universe) });
                                if (fUniverse) {
                                    fUniverse.checked = true;
                                }
                            });
                        }
                        if ($stateParams.level) {
                            (!Array.isArray($stateParams.level) ? [$stateParams.level] : $stateParams.level).forEach(function (level) {
                                var fLevel = lodash.find(lodash.find($scope.filters.criteria, { key: 'level' }).options, { name: parseInt(level) });
                                if (fLevel) {
                                    fLevel.checked = true;
                                }
                            });
                        }
                        if ($stateParams.region) {
                            var basenameCriteria = lodash.find($scope.filters.criteria, { key: 'basename' }).options;
                            (!Array.isArray($stateParams.region) ? [$stateParams.region] : $stateParams.region).forEach(function (region) {
                                var dRegion = decodeURI(region);
                                basenameCriteria.forEach(function (base) {
                                    if (base.name === dRegion) {
                                        base.checked = true;
                                        base.options.forEach(function (subbase) {
                                            subbase.checked = true;
                                            base.open = true;
                                        });
                                    } else {
                                        base.options.forEach(function (subbase) {
                                            if (subbase.name === dRegion) {
                                                subbase.checked = true;
                                            }
                                        })
                                    }
                                });
                            });
                        }
                        if ($stateParams.date) {
                            lodash.find($scope.filters.criteria, { key: 'startDate' }).value = moment($stateParams.date, ["DD-MM-YYYY"]).format("DD/MM/YYYY");
                            $scope.presetDate = moment($stateParams.date, ["DD-MM-YYYY"]).format("MM/DD//YYYY");
                        }

                         if ($stateParams.stock) {
                            lodash.find($scope.filters.criteria, { key: 'stock' }).value = $stateParams.stock;
                         }
                         if ($stateParams.discountPriceMin) {
                             lodash.find($scope.filters.criteria, { key: 'discountPrice' }).min = $stateParams.discountPriceMin;
                         }
                         if ($stateParams.discountPriceMax) {
                            lodash.find($scope.filters.criteria, { key: 'discountPrice' }).max = $stateParams.discountPriceMax;
                         }
                         if ($stateParams.durationMin) {
                             lodash.find($scope.filters.criteria, { key: 'duration' }).min = $stateParams.durationMin;
                         }
                         if ($stateParams.durationMax) {
                            lodash.find($scope.filters.criteria, { key: 'duration' }).max = $stateParams.durationMax;
                         }
                         if ($stateParams.accommodation) {
                            (!Array.isArray($stateParams.accommodation) ? [$stateParams.accommodation] : $stateParams.accommodation).forEach(function (accommodation) {
                                var fAccommodation = lodash.find(lodash.find($scope.filters.criteria, { key: 'accommodation' }).options, { name: decodeURI(accommodation) });
                                if (fAccommodation) {
                                    fAccommodation.checked = true;
                                }
                            });
                        }
                        if ($stateParams.privatizable) {
                             lodash.find($scope.filters.criteria, { key: 'privatizable' }).checked = $stateParams.privatizable === 'true';
                        }

                        $scope.lastMinute = $stateParams.lastMinute === 'true';
                        if ($scope.lastMinute) {
                            $scope.ordering = 'startDate';
                        }

                        $scope.instructor = $stateParams.instructor === 'true';

                        buildResults();
                        checkFacettes();

                        $scope.pending = false;
                        $scope.loading = false;

                        // bind filters $watch
                        var watched = [];
                        $scope.filters.criteria.forEach(function (criterium, i) {
                            if (criterium.type === 'multi') {
                                (criterium.options || []).forEach(function (option, j) {
                                    // watched.push(option.checked);
                                    watched.push('filters.criteria['+ i + '].options[' + j + '].checked');
                                });
                            }
                            else if (criterium.type === 'tree') {
                                (criterium.options || []).forEach(function (option, j) {
                                    option.options.forEach(function (suboption, k) {
                                        // watched.push(suboption.checked);
                                        watched.push('filters.criteria[' + i + '].options[' + j + '].options[' + k + '].checked');
                                    });
                                });
                            }
                            else if (criterium.type === 'bool') {
                                // watched.push(criterium.checked);
                                watched.push('filters.criteria[' + i + '].checked');
                            }
                            else if (criterium.type === 'range') {
                                // watched.push(criterium.min, criterium.max);
                                watched.push('filters.criteria[' + i + '].min');
                                watched.push('filters.criteria[' + i + '].max');
                            }
                            else if (criterium.type === 'date' || criterium.type === 'slider') {
                                // watched.push(criterium.value);
                                watched.push('filters.criteria[' + i + '].value');
                            }
                        });
                        $scope.$watchGroup(watched, lodash.debounce(function (current, previous) {
                            if (!$scope.resultLoading && current.some(function (c, i) { return previous[i] !== c; })) {
                                buildResults();
                                checkFacettes();
                                updateRoute();
                            }
                        }, 250));
                    });

                    $scope.resetFilters = function () {
                        $scope.filters.criteria = angular.copy($scope.savedcriteria);
                    };

                    // show more results
                    $scope.showMore = function () {
                        $scope.limit += $scope.step;
                    };
                    $scope.showMoreBtn = function () {
                        return ($scope.limit < $scope.results.length);
                    };

                    // filter show/hide
                    $scope.toggleFilters = function () {
                        $scope.filters.displayed = !$scope.filters.displayed;
                        $scope.criterias_tags.open = $scope.filters.displayed;
                        $scope.filters.criteria.forEach(function (filter) {
                            filter.open = $scope.filters.displayed;
                        });
                        forceUpdateRendering();
                    };

                    // result tail panel
                    $scope.resultsAreVisible = true;
                    $scope.resultsGutter = '16px';

                    var evalSticky = lodash.throttle(function () {
                        var eResults = document.getElementsByClassName('aqua-internships--list')[0];
                        var eTail = document.getElementsByClassName('aqua-internships--list_tail')[0];

                        if (!eResults || !eTail) { return; }

                        var coordinates = eResults.getBoundingClientRect();
                        var mTop = coordinates.bottom;
                        $timeout(function () {
                            $scope.resultsGutter = mTop < 0 ? (Math.abs(mTop) + 16) + 'px' : '16px';
                            $scope.resultsAreVisible = (
                                (coordinates.top >= 0 && coordinates.top <= ($window.innerHeight || $document[0].documentElement.clientHeight)) ||
                                (coordinates.bottom >= 0 && coordinates.bottom <= ($window.innerHeight || $document[0].documentElement.clientHeight))
                            );
                        });
                    });
                    $window.onresize = function () {
                        evalSticky();
                    };
                    $window.onscroll = function () {
                        evalSticky();
                    };

                    /* link to anchor handler */
                    $scope.goTop = lodash.throttle(function () {
                        var eResults = document.getElementsByClassName('aqua-internships--content')[0];
                        if (!eResults) { return; }

                        var top = eResults.offsetTop;
                        window.scrollTo(0, top);
                    });
                    // route updater
                    function updateRoute() {
                        var startDate = lodash.chain($scope.filters.criteria).find({key: 'startDate'}).result('value').value();
                        var searchParams = {
                            search: $scope.criterias_tags.value.join(' ') || null,
                            activity: lodash.chain($scope.filters.criteria).find({key: 'activity'}).result('options').filter('checked').map('name').value(),
                            universe: lodash.chain($scope.filters.criteria).find({key: 'universe'}).result('options').filter('checked').map('name').value(),
                            region: lodash.chain($scope.filters.criteria).find({key: 'basename'}).result('options').map('options').flatten().filter({checked:true}).map('name').value(),
                            audience: lodash.chain($scope.filters.criteria).find({key: 'audience'}).result('options').filter('checked').map('name').value(),
                            level: lodash.chain($scope.filters.criteria).find({key: 'level'}).result('options').filter('checked').map('name').value(),
                            date: startDate ? moment(startDate, ["DD/MM/YYYY"]).format("DD-MM-YYYY") : null,
                            lastMinute: $scope.lastMinute || null,
                            instructor: $scope.instructor || null,
                            stock: lodash.chain($scope.filters.criteria).find({key: 'stock'}).result('value').value(),
                            durationMin: lodash.chain($scope.filters.criteria).find({key: 'duration'}).result('min').value(),
                            durationMax: lodash.chain($scope.filters.criteria).find({key: 'duration'}).result('max').value(),
                            discountPrice: lodash.chain($scope.filters.criteria).find({key: 'discountPrice'}).result('min').value(),
                            discountPriceMax: lodash.chain($scope.filters.criteria).find({key: 'discountPrice'}).result('max').value(),
                            accommodation: lodash.chain($scope.filters.criteria).find({key: 'accommodation'}).result('options').filter('checked').map('name').value(),
                            privatizable: lodash.chain($scope.filters.criteria).find({key: 'privatizable'}).result('checked').value() || null
                        };

                        $location.search(searchParams);
                    };

                    $scope.checknotranlate = function(text) {
                        if($scope.pattern.noTranslatePattern.test(text)){
                            return "no"
                        } else {
                            return "yes"
                        }
                    }

                    function checkFacettes() {
                        var results = $scope.results || [];
                        var filters = $scope.filters.criteria || [];

                        for (var index = results.length - 1; index >= 0; index--) {
                            var firstTurn = index === results.length - 1;
                            var internship = results[index];

                            // update filters panel
                            for (var jndex = filters.length - 1; jndex >= 0; jndex--) {
                                var criterium = filters[jndex];

                                if (criterium.type === 'multi') {

                                    for (var kndex = criterium.options.length - 1; kndex >= 0; kndex--) {
                                        var value = criterium.options[kndex];
                                        if (firstTurn) {
                                            value.inactive = true;
                                            value.counter = 0;
                                        }
                                        if (internship[criterium.key] === value.name){
                                            value.inactive = false;
                                            value.counter += 1;
                                        }
                                    }

                                } else if (criterium.type === 'tree') {

                                    for (var kndex = criterium.options.length - 1; kndex >= 0; kndex--) {
                                        var option = criterium.options[kndex];
                                        var options = option.options || [];
                                        if (firstTurn) {
                                            option.inactive = true;
                                            option.counter = 0;
                                        }

                                        for (var lndex = options.length - 1; lndex >= 0; lndex--) {
                                            var value = options[lndex];
                                            if (firstTurn) {
                                                value.inactive = true;
                                                value.counter = 0;
                                            }
                                            if (internship[criterium.key] === value.name) {
                                                value.inactive = false;
                                                option.inactive = false;
                                                value.counter += 1;
                                                option.counter += 1;
                                            }
                                        }

                                    }
                                }
                            }
                        }

                        $timeout(function () {
                            $scope.availableDates = angular.copy($scope.dates);
                            $scope.resultLoading = false;
                        });
                    };

                    // add remove date and show datepicker handler
                    $scope.removeDate = function (datefilter) {
                        datefilter.value = '';
                        $timeout(function () {
                            var element = document.getElementById('input-' + datefilter.key);
                            if (element) {
                                element.focus();
                            }
                        }, 1000);
                    };
                    utils.calendarTrad()
                }],
            templateUrl: 'src/views/internships/internships-list.html'
        });
}]);
